/**
 * Live process-conformance summary badge — "⇄ N/M out of order" in the process
 * header, the peer of the latency badge. Shown only when at least one sampled
 * trace ran steps out of the modeled order; fuchsia to match the per-step
 * violation ring (BpmnView / swimlaneCells) so the whole overlay reads as one
 * language. Pure + prop-driven so it's unit-testable without the ProcessMode
 * provider tree.
 */
export function ReorderBadge({
  reorderedTraces,
  conformingTraces = 0,
}: {
  readonly reorderedTraces?: number;
  readonly conformingTraces?: number;
}) {
  if (reorderedTraces == null || reorderedTraces <= 0) return null;
  const total = reorderedTraces + conformingTraces;
  return (
    <span
      className="rounded border border-fuchsia-700/60 bg-fuchsia-950/40 px-2 py-0.5 text-xs font-medium text-fuchsia-300 tabular-nums"
      title={`${reorderedTraces} of ${total} sampled traces ran steps out of the modeled order`}
      data-reorder-badge
    >
      ⇄ {reorderedTraces}/{total} out of order
    </span>
  );
}
